/**
 * @file Overlay-wrapper.tsx
 * @module OverlayWrapper
 * @description Pārklājuma (overlay) konteksta nodrošinātājs Karšu pārlūkam.
 *              Izveido React kontekstu (OverlayManagerContext), kas glabā atlasīto
 *              objektu sarakstu, kartes notikumu un kartes instanci. Apvieno
 *              Overlay (attēlošana) un Select (atlase) komponentes.
 */
import { createContext, useState } from "react";
import Select from "./Select";
import { Overlay } from "./Overlay";
import { Feature, Map, MapBrowserEvent } from "ol";

export interface OverlayManagerData {
	features: Feature[];
	event?: MapBrowserEvent<any>;
	map: Map;
}

export const OverlayManagerContext = createContext<{
	context: OverlayManagerData;
	setContext: React.Dispatch<React.SetStateAction<OverlayManagerData>>;
}>({} as any);

export const OverlayWrapper = ({ map }: { map: Map }) => {
	const [context, setContext] = useState({
		features: [],
		map,
	} as OverlayManagerData);

	return (
		<OverlayManagerContext.Provider value={{ context, setContext }}>
			<Overlay></Overlay>
			<Select></Select>
		</OverlayManagerContext.Provider>
	);
};
